import { AxiosResponse } from 'axios';
import api from './';
import {
  EndTrialPreviewResponse,
  EndTrialRequest,
  EndTrialResponse,
  SubscriptionResponse
} from './types/billing';

const createStripeSubscriptionSession = async () => {
  return await api.post<
    object,
    AxiosResponse<{
      url: string;
    }>
  >(
    '/billing/subscription/session',
    {},
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
};

const createStripeCustomerSession = async () => {
  return await api.post<object, AxiosResponse<{ secret: string }>>('/billing/customer/session', {});
};

const createStripeSubscriptionSessionForTier = async (tier: string) => {
  return await api.post<
    { tier: string },
    AxiosResponse<{
      url: string;
    }>
  >(
    '/billing/subscription/session',
    { tier },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
};

const getSubscriptionInfo = async () => {
  return await api.get<SubscriptionResponse>('/billing/subscription');
};

const getEndTrialPreview = async () => {
  return await api.get<EndTrialPreviewResponse>('/billing/subscription/end-trial-preview');
};

const endStripeTrial = async (request: EndTrialRequest) => {
  return await api.post<EndTrialRequest, AxiosResponse<EndTrialResponse>>(
    '/billing/subscription/end-trial',
    request
  );
};

const syncFeatureFlags = async (userId: string) => {
  return await api.post<{ userId: string }, AxiosResponse<{ success: boolean; message: string }>>(
    '/users/sync-feature-flags',
    { userId }
  );
};

const BillingApi = {
  createStripeSubscriptionSession,
  createStripeCustomerSession,
  createStripeSubscriptionSessionForTier,
  getSubscriptionInfo,
  getEndTrialPreview,
  endStripeTrial,
  syncFeatureFlags
};

export default BillingApi;
